/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateEnvironmentRequestBody,
  UpdateEnvironmentRequestBody$Outbound,
  UpdateEnvironmentRequestBody$outboundSchema,
} from "../components/updateenvironmentrequestbody.js";

export type UpdateEnvironmentSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateEnvironmentRequest = {
  /**
   * The slug of the environment to update
   */
  slug: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  updateEnvironmentRequestBody: UpdateEnvironmentRequestBody;
};

/** @internal */
export type UpdateEnvironmentSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateEnvironmentSecurity$outboundSchema: z.ZodMiniType<
  UpdateEnvironmentSecurity$Outbound,
  UpdateEnvironmentSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function updateEnvironmentSecurityToJSON(
  updateEnvironmentSecurity: UpdateEnvironmentSecurity,
): string {
  return JSON.stringify(
    UpdateEnvironmentSecurity$outboundSchema.parse(updateEnvironmentSecurity),
  );
}

/** @internal */
export type UpdateEnvironmentRequest$Outbound = {
  slug: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UpdateEnvironmentRequestBody: UpdateEnvironmentRequestBody$Outbound;
};

/** @internal */
export const UpdateEnvironmentRequest$outboundSchema: z.ZodMiniType<
  UpdateEnvironmentRequest$Outbound,
  UpdateEnvironmentRequest
> = z.pipe(
  z.object({
    slug: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    updateEnvironmentRequestBody: UpdateEnvironmentRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      updateEnvironmentRequestBody: "UpdateEnvironmentRequestBody",
    });
  }),
);

export function updateEnvironmentRequestToJSON(
  updateEnvironmentRequest: UpdateEnvironmentRequest,
): string {
  return JSON.stringify(
    UpdateEnvironmentRequest$outboundSchema.parse(updateEnvironmentRequest),
  );
}
